import api from "@/services/api/analytics";

const state = {
    isLoading: false,
    isSpatialLoading: false,
    summary: null,
    spatial: { total: 0, points: [] },
};

const getters = {
    loading: (state) => state.isLoading,
    spatialLoading: (state) => state.isSpatialLoading,
    summary: (state) => state.summary,
    spatial: (state) => state.spatial,
};

const actions = {
    async loadSummary({ commit }, filters) {
        commit("loading", { isLoading: true });
        const result = await api.summary(filters);
        commit("setSummary", { summary: result.data });
        commit("loading", { isLoading: false });
    },
    async loadSpatial({ commit }, filters) {
        commit("spatialLoading", { isLoading: true });
        const result = await api.spatial(filters);
        commit("setSpatial", { spatial: result.data });
        commit("spatialLoading", { isLoading: false });
    },
};

const mutations = {
    loading(state, { isLoading }) {
        state.isLoading = isLoading;
    },
    spatialLoading(state, { isLoading }) {
        state.isSpatialLoading = isLoading;
    },
    setSummary(state, { summary }) {
        state.summary = summary;
    },
    setSpatial(state, { spatial }) {
        state.spatial = spatial;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
